export default __webpack_public_path__ + "static/media/HP-OLDLogo.7282d9bc.png";